import PropTypes from 'prop-types';
import React from 'react';

import { Link as OrcLink } from '@ontruck/orc';

const Link = ({ innerRef, className, ...rest }) => (
  <OrcLink ref={innerRef} className={className} {...rest} />
);

Link.propTypes = {
  innerRef: PropTypes.func,
  className: PropTypes.string,
};

Link.defaultProps = {
  innerRef: undefined,
  className: '',
};

export default Link;
